import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CatalogPageModule } from '@app/+catalog/catalog-page.module';
import { FooterModule } from '@app/core/footer/footer.module';
import { HeaderModule } from '@app/core/header/header.module';
import { UserModule } from '@app/core/user/user.module';
import { HomeModule } from '@app/home/home.module';
import { NotFoundModule } from '@app/core/not-found/not-found.module';
import { LinkService } from '@app/shared/services/link/link.service';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { ServerResponseService } from '@app/shared/services/server-response/server-response.service';
import { LikeService } from '@app/shared/services/like/like.service';
import { LocaleService } from '@app/core/i18n';
import { ContentRepositoryService } from './services/content/content-repository.service';
import { PageService } from './content/services/page.service';
import { RoutingService } from './services/routing.service';

import { CookieService, SessionCookieService, PreferencesCookieService } from '@app/core/cookies';
import { PriceDropService } from '@app/shared/services/price-drop/priceDrop.service';
import { WishlistService } from '@app/shared/services/wishlist/wishlist.service';
import { UrlGeneratorService } from '@app/core/i18n';
import { CartModule } from '@app/core/cart/cart.module';
import { FollowingMemberService } from '@app/shared/services/followingMember/followingMember.service';
import { SearchModule } from '@app/core/search/search.module';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { SmartAppBannerModule } from '@app/core/smart-app-banner/smart-app-banner.module';

// Only here for A/B test
import { SkipLinksModule } from './skip-links/skip-links.module';
// To remove after

@NgModule({
  imports: [
    // PAGES
    HomeModule,
    CatalogPageModule,
    // Always the last on the list
    NotFoundModule
  ],
  exports: [
    HeaderModule,
    FooterModule,
    UserModule,
    SmartAppBannerModule,
    CartModule,
    SearchModule,
    ProgressBarModule,
    SkipLinksModule
  ],
  providers: [
    RoutingService,
    PlatformService,
    CookieService,
    LinkService,
    ServerResponseService,
    LikeService,
    SessionCookieService,
    PreferencesCookieService,
    LocaleService,
    ContentRepositoryService,
    PageService,
    PriceDropService,
    UrlGeneratorService,
    WishlistService,
    FollowingMemberService
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
